import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoan } from 'services/loans/manager'
import posthog from 'posthog-js'

export default function useSetOldLoans() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyFirst) => {
            return ManagementAddNewLoan(payload)
        },
        onSuccess: (response, variables) => {
            posthog.capture('old_loan_register_step_completed', {
                step: 'details',
                fund_id: (variables as any)?.moneyPool,
            })
            navigate('/loans/add-old/management/installments', {
                state: { payload: variables, response: response },
            })
        },
        onError: (error: any, variables) => {
            posthog.capture('old_loan_register_failed', {
                step: 'details',
                fund_id: (variables as any)?.moneyPool,
                status: error?.response?.status,
            })
            if (error.response.data[0] === 'Interest cannot be more than 4%.') {
                toast.error('میزان کارمزد نباید بیش از 4 درصد مقدار وام باشد')
            } else {
                toast.error('خطایی رخ داده!')
            }
        },
    })

    return { isLoading, mutate }
}
